import React from "react";

import { OrganisationHeaderProps } from "@models/components/organisation.model";
import { applyLocalization } from "@services/common.service";

const OrganisationHeader: React.FC<OrganisationHeaderProps> = ({
  headerImages,
  logo,
  name,
}) => {
  return (
    <>
      {headerImages ? (
        <div className="fg-banner-block" data-testid="header-image-test">
          <div className="fg-banner-inner">
            <img src={headerImages.url} alt={headerImages.name} />
          </div>
        </div>
      ) : null}
      <div
        className="fg-overview-profile-wrap"
        data-testid={"organisationHeader-test"}
      >
        <div className="container ">
          <div className="fg-overview-profile-block">
            {logo && (
              <div
                className={`fg-overview-profile-pic ${!logo && "fg-icon-light"}`}
              >
                <img src={logo} alt="logo" className="fg-profile-img" />
              </div>
            )}
            <div className="fg-overview-profile-details">
              <div className="fg-overview-profile-name">
                {applyLocalization(name)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrganisationHeader;
